enum IntegrationService {
  HUBSPOT = "hubspot",
  SALESFORCE = "salesforce",
  ZOHO = "zoho",
  DYNAMICS = "dynamics",
}

export default IntegrationService;
